module.exports = __webpack_public_path__ + "img/pro_rcfw3.1b2ad3bf.png";